<template>
    <div>
        <div id="gallery">
            <slot name="drawings-slot"></slot>
            <stack
                    :column-min-width="145"
                    :gutter-width="3.5"
                    :gutter-height="0"
                    monitor-images-loaded
            >
                <stack-item
                        v-for="item in images" v-bind:key="item.id"
                        style="transition: transform 300ms"
                >
                    <div style="overflow: hidden" @click="handleModal(item)">
                        <img v-bind:src="item.thumb" class="thumbs">
                    </div>
                </stack-item>
            </stack>
        </div>
        <BaseModal ref="modal" :painting="painting"/>
    </div>


</template>

<script>
    import { Stack, StackItem } from "vue-stack-grid";

    export default {
        name: "Drawings",
        components: {
            Stack,
            StackItem
        },

        data: function () {
            return {
                images: [
                    {
                        "url": '/paintings/0000-pen-and-ink-lady-dragon-and-hunter.jpg',
                        "thumb": '/paintings/thumbs/0000-pen-and-ink-lady-dragon-and-hunter-thumb.jpg',
                        "year": '',
                        "art_height": '',
                        "art_width": '',
                        "description": '',
                        "memo": '',
                        "owner": 'Unknown',
                        "media": 'Pen and ink',
                        "material": 'illustration board',
                        "title": 'Lady Dragon and Hunter',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1982-the-lady-and-the-unicorn.jpg",
                        "thumb": "/paintings/thumbs/1982-the-lady-and-the-unicorn-thumb.jpg",
                        "year": '1982',
                        "art_height": '11',
                        "art_width": '13',
                        "description": '',
                        "memo": 'Dan used his wife, Barbara Nell Coleman, as the model in this drawing. Barb was proud of that and mentioned it often.',
                        "owner": 'Linda Coleman',
                        "media": 'Pen and ink',
                        "material": 'illustration board',
                        "title": 'The Lady and the Unicorn',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/shipstate-pen-and-ink.jpg",
                        "thumb": "/paintings/thumbs/shipstate-pen-and-ink-thumb.jpg",
                        "year": '1976',
                        "art_height": '41',
                        "art_width": '31',
                        "description": '',
                        "memo": '',
                        "owner": 'Jim W. Coleman',
                        "media": 'Pen and ink',
                        "material": 'illustration board',
                        "title": 'Ship of State',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/untitled-falcon-hunter-pen-and-ink.jpg",
                        "thumb": "/paintings/thumbs/untitled-falcon-hunter-pen-and-ink-thumb.jpg",
                        "year": '',
                        "art_height": '41',
                        "art_width": '31',
                        "description": 'Incomplete',
                        "memo": '',
                        "owner": 'Jim W. Coleman',
                        "media": 'Pen and ink',
                        "material": 'illustration board',
                        "title": 'Untitled and incomplete',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1982-untitled-aus5-spaceship-pen-and-ink.jpg",
                        "thumb": "/paintings/thumbs/1982-untitled-aus5-spaceship-pen-and-ink-thumb.jpg",
                        "year": '1982',
                        "art_height": '',
                        "art_width": '',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Pen and ink',
                        "material": 'illustration board',
                        "title": 'Untitled',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/0000-the-cycle-pen-and-ink.jpg",
                        "thumb": "/paintings/thumbs/0000-the-cycle-pen-and-ink-thumb.jpg",
                        "year": '',
                        "art_height": '',
                        "art_width": '',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Pen and ink',
                        "material": 'illustration board',
                        "title": 'The Cycle',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1978-5-the-termite-mound-20x30-pen.jpg",
                        "thumb": "/paintings/thumbs/1978-5-the-termite-mound-20x30-pen-thumb.jpg",
                        "year": '1978',
                        "art_height": '30',
                        "art_width": '20',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Pen and ink',
                        "material": 'illustration board',
                        "title": 'The Termite Mound',
                        "submitted_by": ''
                    }
                     // {
                    //     "url": "/paintings/.jpg",
                    //     "thumb": "/paintings/thumbs/.jpg",
                    // },

                ],
                painting: {},
            };
        },



        computed: {},
        mounted() {
            this.painting = this.images[0]
        },
        ready: function () {
        },
        methods: {
            handleModal(item) {
                this.painting = item;
                this.$refs.modal.showModal();
            }
        }
    }
</script>

<style>
    .box {
        max-width: 100%;
        padding-top: 10px;
        max-height: 100vh;
    }
    .thumbs {
        width: 150px;
        min-width: 150px;
        max-width: 150px;
    }
</style>
